import { forwardRef, type HTMLAttributes } from 'react';
import cn from 'classnames';

import { Picture } from '@/components/ui/Picture/Picture';

import { Tile } from '../Tile/Tile';
import { TilesBg } from '../TilesBg/TilesBg';

import boxPng from '/img/dice-game/box.png';
import boxWebp from '/img/dice-game/box.webp';

interface BoxTileProps extends HTMLAttributes<HTMLDivElement> {
  isActive?: boolean;
}

const BoxTile = forwardRef<HTMLDivElement, BoxTileProps>((props, ref) => {
  return (
    <Tile
      ref={ref}
      {...props}
      variant={props.isActive ? 'dark' : 'grey'}
      className={cn(props.className, 'flex items-center justify-center')}
    >
      <Picture
        className="relative z-[2] w-full h-full"
        img={boxPng}
        webp={boxWebp}
        alt="cash"
      />
      {props.isActive && <TilesBg variant="green-active" />}
    </Tile>
  );
});

export { BoxTile };
